import React from "react";
import { Box, Grid, Skeleton, Container, Button } from "@mui/material";
import Header from "../header/Header";
import DummyHeader from "../header/DummyHeader";

export default function HomeSkeleton(props:any) {

  const { isShowHeader=false} = props;
  return (
    <Box sx={{ bgcolor: "#fffaf7" }}>
      {/* Hero Section */}
      <Container maxWidth="lg" sx={{ py: { xs: 4, md: 8 } }}>
        <Grid container spacing={4} alignItems="center">
          {isShowHeader && <DummyHeader />}

          {/* Left Text Content */}
          <Grid item xs={12} md={6}>
            <Skeleton variant="text" width="60%" height={50} />
            <Skeleton variant="text" width="80%" height={30} sx={{ mb: 1 }} />
            <Skeleton variant="text" width="90%" height={20} sx={{ mb: 1 }} />
            <Skeleton variant="text" width="70%" height={20} sx={{ mb: 3 }} />

            {/* Buttons */}
            <Box display="flex" gap={2}>
              <Skeleton
                variant="rectangular"
                width={130}
                height={45}
                sx={{ borderRadius: 2 }}
              />
              <Skeleton
                variant="rectangular"
                width={130}
                height={45}
                sx={{ borderRadius: 2 }}
              />
            </Box>
          </Grid>

          {/* Right Hero Image */}
          <Grid item xs={12} md={6}>
            <Skeleton
              variant="rectangular"
              width="100%"
              height={400}
              animation="wave"
              sx={{ borderRadius: 4 }}
            />
          </Grid>
        </Grid>
      </Container>

      {/* Section: Upcoming Offerings */}
      <Container maxWidth="lg" sx={{ py: 6 }}>
        <Skeleton variant="text" width="40%" height={35} sx={{ mb: 1 }} />
        <Skeleton variant="text" width="70%" height={20} sx={{ mb: 3 }} />
        <Box display="flex" justifyContent="flex-end" mb={2}>
          <Skeleton
            variant="rectangular"
            width={200}
            height={40}
            sx={{ borderRadius: 2 }}
          />
        </Box>
        <Grid container spacing={2}>
          {[1, 2, 3].map((item) => (
            <Grid item xs={12} sm={4} key={item}>
              <Skeleton
                variant="rectangular"
                width="100%"
                height={200}
                animation="wave"
                sx={{ borderRadius: 3 }}
              />
            </Grid>
          ))}
        </Grid>
      </Container>

      {/* Section: New on Temple Dekho */}
      <Container maxWidth="lg" sx={{ py: 6 }}>
        <Skeleton variant="text" width="50%" height={35} sx={{ mb: 1 }} />
        <Skeleton variant="text" width="70%" height={20} sx={{ mb: 3 }} />
        <Grid container spacing={2}>
          {[1, 2, 3].map((item) => (
            <Grid item xs={12} sm={4} key={item}>
              <Skeleton
                variant="rectangular"
                width="100%"
                height={180}
                animation="wave"
                sx={{ borderRadius: 3 }}
              />
            </Grid>
          ))}
        </Grid>
      </Container>

      {/* Section: Pujas */}
      <Container maxWidth="lg" sx={{ py: 6 }}>
        <Skeleton variant="text" width="40%" height={35} sx={{ mb: 1 }} />
        <Skeleton variant="text" width="60%" height={20} sx={{ mb: 3 }} />
        <Box display="flex" justifyContent="flex-end" mb={2}>
          <Skeleton
            variant="rectangular"
            width={180}
            height={40}
            sx={{ borderRadius: 2 }}
          />
        </Box>
        <Grid container spacing={2}>
          {[1, 2, 3].map((item) => (
            <Grid item xs={12} sm={4} key={item}>
              <Skeleton
                variant="rectangular"
                width="100%"
                height={220}
                animation="wave"
                sx={{ borderRadius: 3 }}
              />
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
